import { render, staticRenderFns } from "./CAAG1110.vue?vue&type=template&id=243a86a8&scoped=true"
import script from "./CAAG1110Controller.ts?vue&type=script&lang=ts&external"
export * from "./CAAG1110Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CAAG1110.vue?vue&type=style&index=0&id=243a86a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243a86a8",
  null
  
)

export default component.exports